var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("label", { class: _vm.classes, attrs: { for: _vm.id } }, [
    _c("input", {
      class: _vm.inputClasses,
      attrs: { id: _vm.id, type: "checkbox", disabled: _vm.disabled },
      domProps: { value: _vm.value, checked: _vm.checked },
      on: {
        click: _vm.click,
        keydown: function($event) {
          return _vm.keyDown($event)
        }
      }
    }),
    _vm._v(" "),
    _c("span", { class: _vm.mdsNS("form__checkbox-visible-wrap") }, [
      _c("span", { class: _vm.mdsNS("form__checkbox-visual") }, [
        _c(
          "svg",
          {
            class: _vm.mdsNS("icon form__checkbox-checked-icon"),
            attrs: { "aria-hidden": "true" }
          },
          [_c("use", { attrs: { "xlink:href": "#check--s" } })]
        ),
        _vm._v(" "),
        _c(
          "svg",
          {
            class: _vm.mdsNS("icon form__checkbox-indeterminate-icon"),
            attrs: { "aria-hidden": "true" }
          },
          [_c("use", { attrs: { "xlink:href": "#minus--s" } })]
        )
      ]),
      _vm._v(" "),
      _c("span", { class: _vm.mdsNS("form__checkbox-text") }, [
        _vm._v(" " + _vm._s(_vm.label) + " ")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }